<template>
  <div class='indexbox'>

    <wallet-head show_type="8" />

    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/notice/list" :data="{}">
      <div class="list">

        <div class="item" v-for="(val, index) in list" :key="index" @click="router(`newdel?id=${val.id}`)">
          <!-- <p>{{ val.title }}</p> -->
          <p class="one" v-if="getLang() == 'zh'">{{ val.title }}</p>
          <p class="one" v-if="getLang() == 'en'">{{ val.title_en }}</p>
          <p class="one" v-if="getLang() == 'tw'">{{ val.title_tw }}</p>
          <p>{{ val.created_at }}</p>
        </div>
      </div>
    </vant-up-down>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      page: 1,
      loading: false,
      finished: false,
    }
  },
  created() {
    this.up_down()
  },
  methods: {},
}
</script>
<style lang='less' scoped>
.list {
  width: 100%;
  padding: 10px 15px;

  .item {
    width: 100%;
    background: #212748;
    margin: 0 0 3vw 0;
    border-radius: 6px;
    padding: 10px;
    font-size: 15px;
    border: 1px solid #3e75ad;

    p {
      &:nth-child(2) {
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>